export default __webpack_public_path__ + "static/team-1-55e2f9b3018edc22fe22eaaf8bd62519.jpg";